// types
import { DefaultConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 74;

export const SESSION_TIMEOUT_WARNING_MINS = 2;
export const MAX_CONCURRENT_UPLOADS = 5;

export const TWO_ALPHA_NUMERIC_PATTERN = /[a-zA-Z0-9].*[a-zA-Z0-9]/;
export const DESIGN_STUDION_DND_TYPE = 'DESIGN_STUDIO';

// ==============================|| HIDE BREADCRUMBS PAGES ||============================== //

export const HIDE_BREADCRUMBS_PAGES: string[] = ['design/design-studio', 'review/image-viewer', 'general-settings'];

// ==============================|| THEME CONFIG ||============================== //
const config: DefaultConfigProps = {
  fontFamily: `Lato`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: true,
  container: false,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR,
  themeContrast: false
};

export const DOCUMENT_LIST_DURATION = 30000; // 30 seconds
export const BATCH_STATUS_UPDATE_DURATION = 5000; // 5 seconds

export const DESIGN_STUDIO_CANVAS_DEFAULT_RATIO_VALUE = 0.01;
export const DESIGN_STUDIO_CANVAS_ZOOM_VARIATION = 25;

export default config;
